module.exports = __webpack_public_path__ + "files/4b36d53f97d3f5736c3cae8e7a5b0fb6.png";